module.exports = __webpack_public_path__ + "img/编排与应用整体.213c9bc5.gif";